import React from "react";
import "./QuickEntryRecordsPane.scss";

export interface QuickEntryRecordsPaneSummary {
    readonly recordsRequested: readonly string[];
    readonly serviceDateFrom?: string;
    readonly serviceDateTo?: string;
}

export interface QuickEntryRecordsPaneProps {
    readonly summary: QuickEntryRecordsPaneSummary;
}

/**
 * Quick Entry's read-only Records tab (Spec #34102 / F1d, AC10). Sourced
 * from values already captured on the Quick Entry row list - no new data
 * fetch, no editable controls (this pane is a summary, not a form; edits go
 * back through the Request Info row list, not here).
 */
const QuickEntryRecordsPane: React.FC<QuickEntryRecordsPaneProps> = (props) => {
    return (
        <div className="qe-records-pane">
            <div className="qe-records-pane__header">
                <h2 className="qe-records-pane__title">Records</h2>
                <p className="qe-records-pane__summary">
                    Release scope confirmed in Quick Entry. Record attachment is handled in the Record Attachment stage after the transaction is created.
                </p>
            </div>
            <div className="qe-records-pane__body">
                <div className="qe-records-pane__field">
                    <span className="qe-records-pane__label">Records Requested</span>
                    <ul className="qe-records-pane__value qe-records-pane__record-list">
                        {/* key by position, not by text: the text now carries the Other Documents
                            description, so keying on it unmounted and remounted the row and its
                            icon on every keystroke (Mike Hamilton, PR !10721 round 4). The list
                            order is releaseInfo's, which is stable. */}
                        {props.summary.recordsRequested.map((item, index) => (
                            <li key={index} className="qe-records-pane__record-item">
                                <svg className="qe-records-pane__record-icon" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.9}>
                                    <path d="M20 6 9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                {/* AB#39380: an Other Documents description can run to 2,000
                                    characters - clamped so one record type cannot push the rest
                                    of the pane off screen, with the full text on the tooltip. */}
                                <span className="qe-records-pane__record-text" title={item}>{item}</span>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="qe-records-pane__field">
                    <span className="qe-records-pane__label">Date Range of Service</span>
                    <span className="qe-records-pane__value qe-records-pane__date-range">
                        <svg className="qe-records-pane__date-range-icon" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}>
                            <rect x={3} y={4.5} width={18} height={16} rx={2} />
                            <path d="M3 9h18M8 2.5v4M16 2.5v4" strokeLinecap="round" />
                        </svg>
                        {props.summary.serviceDateFrom ?? "-"} to {props.summary.serviceDateTo ?? "-"}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default QuickEntryRecordsPane;
